import {defineStore} from "pinia";
import {getAuthenticatedRequest} from "@/stores/AuthenticatedRequest.js";
import {useApi} from "@/services/useApi.js";

export const useManagementStore = defineStore('management', {
  state: () => ({
    boostOrders: [],
    boostFilteredOrders: [],
    boostOrdersSort: null,
    stores: []
  }),
  getters: {
    getOrders: state => type => state[`${type}Orders`],
    limitedOrders: (state) => {
      return (type, limit) => {
        const list = state[`${type}Orders`] || []
        return limit ? list.slice(0, limit) : list
      }
    },
    getSummary: (state) => (type, orderType) => {
      return 'summarizeOrders(state[`${type}FilteredOrders`], ORDER_TYPES[orderType].summaryFields)'
    },
    getStores: (state) => {
      return state.stores
    },
  },
  actions: {
    async action_getStores() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10033
      };
      //console.log('action_getStores: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_getStores Success: ', response);
          this.setStores(response.data.stores)
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
    async action_addStore(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10060,
        'store': payload
      };
      //console.log('action_addStore: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_addStore Success: ', response);
          return true;
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
    async action_updateStore(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10061,
        'store': payload
      };
      //console.log('action_updateStore: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_updateStore Success: ', response);
          return true;
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
    async action_deleteStore(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 10062,
        'store': payload
      };
      //console.log('action_deleteStore: ', request);
      return await useApi(
        request,
        (response) => {
          //console.log('action_deleteStore Success: ', response);
          return true;
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
    async action_getUnderReviewAccounts() {
      const request = {
        ...getAuthenticatedRequest(),
        'subRequest': 1019
      };
      //console.log('action_addStore: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_getUnderReviewAccounts Success: ', response);
          return {
            result: true,
            data: response.data.accounts ? response.data.accounts : []
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
    async action_changeVerificationState(payload) {
      const request = {
        ...getAuthenticatedRequest(),
        subRequest: 1020,
        profile: {
          id: payload.id,
          verificationState: payload.verificationState,
          ...(payload.verificationState === 'Rejected' &&
            payload.verificationNote && {
              verificationNote: payload.verificationNote
            })
        }
      };
      console.log('action_changeVerificationState: ', request);
      return await useApi(
        request,
        (response) => {
          console.log('action_changeVerificationState Success: ', response);
          return {
            result: true
          };
        },
        (errorMessage) => {
          //console.log('Handle Credential Expired: ', errorMessage);
          return false;
        },
        (errorMessage) => {
          //console.log('Handle Failure: ', errorMessage);
          return false;
        }
      );
    },
    setStores(payload) {
      this.stores = payload
    }
  }
})